import { render, staticRenderFns } from "./PaymentStatusPage.vue?vue&type=template&id=2a4e265c&scoped=true"
import script from "./PaymentStatusPage.vue?vue&type=script&lang=js"
export * from "./PaymentStatusPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentStatusPage.vue?vue&type=style&index=0&id=2a4e265c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e265c",
  null
  
)

export default component.exports